/*
 * 验证工具类
 * 提供验证方法
 * 验证邮箱
 * 验证密码
 * 验证手机号
 * 验证验证码
 * 验证用户名
 * 验证昵称
 * 验证身份证
 */
export default function verification() {
  // 验证邮箱
  const verifyEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  // 验证密码
  const verifyPassword = (password: string) => {
    return password.length >= 6 && password.length <= 30
  }

  // 判断空值
  const verifyEmpty = (value: string) => {
    return value.trim() === ''
  }

  // 验证手机号
  const verifyPhone = (phone: string) => {
    return /^1[3-9]\d{9}$/.test(phone)
  }

  // 验证验证码
  const verifyCode = (code: string) => {
    return code.length === 6
  }

  // 验证用户名
  return {
    verifyEmail,
    verifyPassword,
    verifyEmpty,
    verifyPhone,
    verifyCode
  }
}